import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * true cuando el sistema del usuario pide reducir el movimiento.
 *
 * Se usa para desactivar los efectos de parallax y el zoom del fondo de
 * Speakers, que son decorativos y pueden causar mareo o distraccion.
 */
export const usePrefersReducedMotion = () => {
  const [prefiereReducido, setPrefiereReducido] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setPrefiereReducido(e.matches);

    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return prefiereReducido;
};

export default usePrefersReducedMotion;
